import { Navigate, Route, createBrowserRouter, createRoutesFromElements, RouterProvider } from 'react-router-dom';
import { ROUTER_PATHS } from '../../lib/util/router/router-paths';
import { NOT_FOUND_ROUTE_PATH } from '../../lib/util/router/router-consts';
import { EndUserFinder } from './EndUserFinder';

export function ClientRoutes() {
  // A finder link can carry parameters, so a redirect on the way to the finder has to keep them:
  // a bare `to` string would resolve to an empty query.
  const finderRoute = { pathname: ROUTER_PATHS.finder, search: window.location.search };

  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path={ROUTER_PATHS.home} element={<Navigate to={finderRoute} />} />
        <Route path={ROUTER_PATHS.finder} element={<EndUserFinder />} />
        <Route path={NOT_FOUND_ROUTE_PATH} element={<Navigate to={finderRoute} />} />
      </>
    )
  );

  return <RouterProvider router={router} />;
}
